<template>
  <div class="password-backdrop">
    <div class="password-modal">

      <header class="password-modal-header">
        <slot v-if="!this.isEncrypted" name="header">{{ $t("downloadview.encryptDocument") }}</slot>
        <slot v-else name="header">{{ $t("downloadview.decryptDocument") }}</slot>
        <button type="button" class="password-btn-close" @click="close">x</button>
      </header>

      <section class="password-modal-body">
        <div v-if="!this.isEncrypted">
          <label>{{ $t("downloadview.passwordDoc") }}</label>
          <input
            type="text"
            id="password"
            class="password-input"
            style="-webkit-text-security: disc;"
            v-model="pass"
          />

          <label>{{ $t("downloadview.confirmPasswordDoc") }}</label>
          <input
            class="password-input"
            @keyup="confirmPassword"
            type="text"
            id="passwordConfirm"
            style="-webkit-text-security: disc;"
            v-model="passConfirm"
          />

          <p id="invalidPass" class="password-validation-message" v-if="invalidPasswords">
            {{ $t("downloadview.passwordDoesNotMatch") }}
          </p>
        </div>

        <div v-else>
          <label>{{ $t("downloadview.passwordDoc") }}</label>
          <input
            type="text"
            id="decryptPassword"
            class="password-input"
            style="-webkit-text-security: disc;"
            v-model="passConfirm"
          />
        </div>
      </section>

      <footer class="password-modal-footer">
        <button
          id="confirmButton"
          @click="confirmButton"
          :disabled="isSaveDisabled"
          type="submit"
          class="password-btn-green"
        >
          {{ $t("downloadview.confirmButton") }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script>
import EnvProvider from 'jvjr-docker-env';

export default {
    name: 'PasswordModal',
    props: {
        docName: String,
        isEncrypted: Boolean,
        documentId: String
    },
    data() {
        return {
            pass: '',
            passConfirm: '',
            invalidPasswords: false,
            sibmitDisabled: false
        }
    },
    computed: {
        isSaveDisabled() {
            return this.invalidPasswords || this.isEmpty;
        },
        isEmpty() {
            return this.passConfirm.trim() === '';
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },
        confirmButton() {

            let formData = new FormData()
            formData.append('docId', this.documentId)
            formData.append('document_name', this.docName)
            formData.append('pswd', this.passConfirm)

            if (!this.isEncrypted) {
                this.axios.post(EnvProvider.value('API_URL') + this.$root.API_ENCRYPT_DOC, formData
                ).then((response) => {
                    if (response.status === 200) {
                        console.log('PDF encrypted successfuly')
                        this.$store.commit('pushMsg', { type: 'ok', text: this.$t("StoreCommits.documentEncryptSuccess") })
                        this.close()
                    }
                })
            } else {
                this.axios.post(EnvProvider.value('API_URL') + this.$root.API_DECRYPT_DOC, formData
                ).then((response) => {
                    if (response.status === 200) {
                        console.log('PDF decrypted successfuly')
                        this.$store.commit('pushMsg', { type: 'ok', text: this.$t("StoreCommits.documentDecryptionSuccess") })
                        this.close()
                    }
                }).catch((error) => {
                    if (error.response.status === 422) {
                        this.$store.commit('pushMsg', { type: 'error', text: this.$t("StoreCommits.wrongPassword") })
                    } else {
                        console.log(error)
                    }

                })

            }
        },
        confirmPassword() {
            if (this.pass !== this.passConfirm) {
                this.invalidPasswords = true
                this.submitDisabled = true
            } else {
                this.invalidPasswords = false
                this.submitDisabled = false
            }
        },
    },
};
</script>

<style scoped lang="scss" src="@/assets/css/components/PasswordModal.scss"/>
